import { Rpc, RpcGroup } from "effect/rpc";
import { BeginCardReadRequest, CardReadOperationRequest, CardReadOperationReceipt, CardReadOperationStatus } from "./operations.schema";

/** Capability-based card operations shared by bridge and kiosks.
 * A status or abandonment request can never perform another physical read.
 * @since 1.1.11
 * @example const rpcs = CardReadOperationRpcs;
 */
export class CardReadOperationRpcs extends RpcGroup.make(
  Rpc.make("FrontDeskBeginCardRead", { payload: BeginCardReadRequest, success: CardReadOperationReceipt }),
  Rpc.make("FrontDeskGetCardReadStatus", { payload: CardReadOperationRequest, success: CardReadOperationStatus }),
  Rpc.make("FrontDeskAbandonCardReadOperation", { payload: CardReadOperationRequest, success: CardReadOperationStatus }),
) {}
